import React from "react";
import { PagesContainer } from "../../containers";
import { InfractionDisputeScreen } from "../../screens";

const InfractionDispute = (props) => {
  return (
    <PagesContainer {...props}>
      <InfractionDisputeScreen {...props} />
    </PagesContainer>
  );
};

InfractionDispute.defaultProps = {};

export default InfractionDispute;
